import StepEmail from './StepEmail'
import StepEnd from './StepEnd'
import StepIdentityCheck from './StepIdentityCheck'
import StepLocations from './StepLocations'
import StepLogin from './StepLogin'
import StepLogo from './StepLogo'
import StepPhone from './StepPhone'
import StepProfile from './StepProfile'

export default {
  StepEmail,
  StepProfile,
  StepLogo,
  StepLocations,
  StepPhone,
  StepIdentityCheck,
  StepLogin,
  StepEnd,
}
